import * as React from "react"
import { DrawerSeeker } from "@ui-seeker/core"

import { ModalCarouselImagesSeeker, ModalCarouselVideosSeeker } from "@components"
import { multimediaCarouselImages, multimediaCarouselImagesIsOpen, multimediaCarouselInitPos, multimediaCarouselVideos, multimediaCarouselVideosIsOpen } from "@signals"
import AdminScrapingDataReviewDetailsDrawerContent from "./Content"
import { adminScrapingDataReviewShowDetails, adminScrapingDataReviewDetails, isModalVideo } from "../@signals"


export default function AdminScrapingDataReviewDetailsDrawer() {
    return <DrawerSeeker
		hideActions
		isOpen={adminScrapingDataReviewShowDetails.value}
		controller={() => adminScrapingDataReviewDetails.value = {}}
		title="SKU Details"
		width="30%"
	>
    	<AdminScrapingDataReviewDetailsDrawerContent />

		<ModalCarouselImagesSeeker
            isOpen={multimediaCarouselImagesIsOpen.value}
            controller={ () => multimediaCarouselImages.value = [] }
            title='Images'
            multimedia={multimediaCarouselImages.value}
            initPos={multimediaCarouselInitPos.value}
        />

        <ModalCarouselVideosSeeker
            isOpen={multimediaCarouselVideosIsOpen.value}
            controller={ () => multimediaCarouselVideos.value = [] }
            multimedia={multimediaCarouselVideos.value}
            initPos={multimediaCarouselInitPos.value}
        />

    </DrawerSeeker>
}